import { createRequestActions } from 'store/actionCreators'

export const companyStatsRequest = createRequestActions('COMPANY_STATS/REQUEST', () => ({
  request: {
    url: '/organization-stats',
  },
}))
